<template>
    <div class="relevant-strategy">
        <div class="relevant-strategy-title">
            <gameInfoTitle title="相關攻略">
            </gameInfoTitle>
        </div>
        <div class="relevant-strategy-content">
            <div class="relevant-strategy-item" v-for="(item, index) in strategyList" :key="index"
                @click="goDetail(item.id)">
                <div class="relevant-strategy-item-img">
                    <img :src="item.src" alt="">
                </div>
                <div class="relevant-strategy-item-desc">
                    <div class="desc-title">
                        {{ item.title }}
                    </div>
                    <div class="desc-content">
                        {{ item.content }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import gameInfoTitle from './gameInfoTitle.vue';
export default {
    components: {
        gameInfoTitle
    },
    props: {
        strategyList: {
            type: Array,
            default: () => [
                {
                    src: 'https://ts1.cn.mm.bing.net/th/id/R-C.cbf1a98f7cdca37d800ffb58e2ba6035?rik=k%2brgsf8TPYqxmw&riu=http%3a%2f%2fimg.pconline.com.cn%2fimages%2fupload%2fupc%2ftx%2fwallpaper%2f1301%2f10%2fc1%2f17280208_1357799853560.jpg&ehk=BGVEYcmYSa5A4ixvEnQdHU%2fQcF24RybBito22e4Xrtg%3d&risl=&pid=ImgRaw&r=0',
                    title: '攻略1',
                    content: 'dadadasdada'
                },
                {
                    src: 'https://ts1.cn.mm.bing.net/th/id/R-C.cbf1a98f7cdca37d800ffb58e2ba6035?rik=k%2brgsf8TPYqxmw&riu=http%3a%2f%2fimg.pconline.com.cn%2fimages%2fupload%2fupc%2ftx%2fwallpaper%2f1301%2f10%2fc1%2f17280208_1357799853560.jpg&ehk=BGVEYcmYSa5A4ixvEnQdHU%2fQcF24RybBito22e4Xrtg%3d&risl=&pid=ImgRaw&r=0',
                    title: '攻略1',
                    content: 'dadadasdada'
                },
                {
                    src: 'https://ts1.cn.mm.bing.net/th/id/R-C.cbf1a98f7cdca37d800ffb58e2ba6035?rik=k%2brgsf8TPYqxmw&riu=http%3a%2f%2fimg.pconline.com.cn%2fimages%2fupload%2fupc%2ftx%2fwallpaper%2f1301%2f10%2fc1%2f17280208_1357799853560.jpg&ehk=BGVEYcmYSa5A4ixvEnQdHU%2fQcF24RybBito22e4Xrtg%3d&risl=&pid=ImgRaw&r=0',
                    title: '攻略1',
                    content: 'dadadasdada'
                }
            ]
        }
    },
    methods: {
        goDetail(id) {
            if(!id) return;
            this.$router.push({
                name: "topicPage",
                query: { topicId: id, isGame: "true" },
            });
        },
    }
}
</script>

<style scoped lang="scss">
.relevant-strategy {
    padding: .25rem .42rem;
    background-color: white;
    user-select: none;
    cursor: pointer;

    &-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;

        .relevant-strategy-item {
            padding: .1rem 0;
            display: flex;
            height: 1.3rem;
            width: 100%;
            position: relative;

            &-img {
                width: 2.2rem;
                height: 100%;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            &-desc {
                padding: .22rem;
                flex: 1;
                width: 0;

                .desc-title {
                    font-size: .28rem;
                    color: black;
                    font-weight: bold;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;

                    p {}
                }

                .desc-content {
                    color: #808492;
                    font-size: .22rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-word;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                }
            }
        }

        .relevant-strategy-item:not(:last-child) {
            border-bottom: .01rem solid #e5e5e5;
        }
    }
}
</style>